<template>
    <div class="bg">
        <v-container>
          <div class="center nav">
            <v-icon style="position: absolute; left: 20px;color:#fff" @click="previous()"
              >mdi-arrow-left</v-icon
            >
            <v-spacer></v-spacer>
            <h2 style="margin-bottom: 0;color:#fff">Setup - Staff</h2>
            <v-spacer></v-spacer>
          </div>
           <!-- content -->
          <div :style="`height:${height}px;min-height: 70vh;border-radius: 20px;background:#fff;overflow: scroll;`">
            <v-container>
                <!-- data_emp -->
                <div v-if="data_emp === true">
                <div>
                    <p style="color: var(--neutral-black, #0C092A);
                        font-family: Rubik;
                        font-size: 18px !important;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 135%;
                        padding-bottom:20px;">Siam Paragon branch</p>
                </div>
                <div class="row" style="border-radius: 16px;
                        border: 2px solid #EFEEFC;
                        background: #EFEEFC;height: 76px;margin:10px 0;" v-for="n in data" :key="n">
                    <div class="col-3" style="display:flex;align-items:center;">
                        <v-avatar
                            color="#fff"
                            size="46"
                            >
                            <v-icon color="#25388D" size="26">mdi-account</v-icon>
                        </v-avatar>
                    </div>
                    <div class="col-7" style="display:flex;align-items:center;">
                        <p style="margin:0">{{n.displayName}}</p>
                    </div>
                    <div class="col-2" style="display:flex;align-items:center;" >
                        <v-icon @click="getDataEdit(n)">mdi-pencil</v-icon>
                    </div>
                </div>
                </div>
                <!-- data_emp -->

                <!-- edit -->
                <div v-if="edit === true">
                    <div>
                    <p style="color: var(--neutral-black, #0C092A);
                        font-family: Rubik;
                        font-size: 18px !important;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 135%;
                        padding-bottom:15px;">Setup - Staff</p>
                </div>
                <div>
                    <p><span style="color:#ff0000">* </span>Branch</p>
                    <v-select
                        v-model="update.masBranchID"
                        :items="dataBranch"
                        placeholder="Enter branch"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-select>
                    <p><span style="color:#ff0000">* </span>Name - Surname</p>
                     <v-text-field
                     v-model="update.displayName"
                        placeholder="Enter name"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-text-field>
                    <p><span style="color:#ff0000">* </span>Position</p>
                    <v-select
                        placeholder="Choose amount of baht"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-select>
                    <p><span style="color:#ff0000">* </span>Telephone</p>
                     <v-text-field
                        placeholder="Enter telephone"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-text-field>
                </div>
                <div style="display:flex;justify-content:center;">
                    <v-btn block dark color="#07B53B" class="btn-ok">Connect your LINE</v-btn>
                </div>
                </div>
                <!-- edit -->
            </v-container>
          </div>
          <!-- content -->
          <div class="foot">POWER BY  BETASK CONSULTING</div>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios' // api
export default {

  data () {
    return {
      height: '',
      data_emp: true,
      edit: false,
      session: this.$session.getAll(),
      data: [],
      add: {
        masBranchID: '',
        userTypeGroup: '',
        displayName: '',
        tel: '',
        shopId: this.$session.getAll().data.shopId,
        EXPIRY_DATE: ''
      },
      update: {
        masBranchID: '',
        userTypeGroup: '',
        displayName: '',
        tel: '',
        shopId: '',
        EXPIRY_DATE: ''
      },
      dataBranch: []
    }
  },

  mounted () {
    this.checkDeviceHeight()
    this.getData()
    this.getDataBranch()
  },

  methods: {
    checkDeviceHeight () {
      const viewportHeight = window.innerHeight
      this.height = viewportHeight - 162
    },
    getData () {
      axios
        .get(this.DNS_IP + '/system_user/get?shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          this.data = res.data
        })
    },
    getDataEdit (n) {
      this.data_emp = false
      this.edit = true
      axios
        .get(this.DNS_IP + '/system_user/getID?userId=' + n.userId)
        .then(res => {
          console.log(typeof (res.data.masBranchID))
          // if (res) {
          //     res.data.masBranchID = res.data.parsInt(masBranchID)
          // }
          Object.assign(this.update, res.data)
          console.log('update', this.update.displayName)
        })
    },
    getDataBranch () {
      this.dataBranch = []
      axios
        .get(
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          rs.map(el => {
            var s = {}
            s.value = el.masBranchID
            s.text = el.masBranchName
            this.dataBranch.push(el)
          })
        })
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    }

  }
}
</script>

<style scoped>
    .bg {
        background: #25388D;
        height: 100vh;
        width: 100%;
    }
    .nav {
  display: flex;
  align-items: center;
  height: 100px;
}

.foot {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}

p {
    color: #000;
    margin: 16px 0 0
}

/
.container {
    padding:12px 15px 0 15px;
}
.btn-ok{
    border-radius: 20px;
    height: 56px !important;
    position: absolute;
    bottom: 8%;

}
.v-btn--block {
    min-width: 85% !important;
}

.image {
    border-radius: 20px;
    background: var(--neutral-grey-5, #EEF3FC);
    width: 100%;
    height: 233px;
    flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/staff.vue